import { PBTCasesAction, PBTCasesActionType } from './action-types';
import type { IPBTCasesState } from './types';

// PBT cases reducer name
export const pbtCasesReducerName = 'pbtCasesReducer';

// PBT cases initial state
export const pbtCasesInitialState: IPBTCasesState = {
  cases: [],
  isLoading: false,
  hasError: false,
  errorMessage: null,
  isUpdating: false,
  updateError: null,
};

// PBT cases reducer
export function pbtCasesReducer(
  prev: IPBTCasesState = pbtCasesInitialState,
  action: PBTCasesAction): IPBTCasesState {
  switch (action.type) {

    case PBTCasesActionType.REQUEST_CASES:
      return {
        ...prev,
        isLoading: true,
        hasError: false,
        errorMessage: null,
      };

    case PBTCasesActionType.RECEIVE_CASES: {
      return {
        ...prev,
        isLoading: false,
        hasError: false,
        cases: action.data,
      };
    }

    case PBTCasesActionType.ERROR_CASES:
      return {
        ...prev,
        isLoading: false,
        hasError: true,
        errorMessage: action.errorMessage ?? null,
      };

    case PBTCasesActionType.RESET_CASES:
      return { ...pbtCasesInitialState };

    case PBTCasesActionType.UPDATE_CASE_REQUEST:
      return {
        ...prev,
        isUpdating: true,
        updateError: null,
      };

    case PBTCasesActionType.UPDATE_CASE_SUCCESS:
      return {
        ...prev,
        isUpdating: false,
        updateError: null,
        cases: prev.cases.map(c =>
          c.id === action.updatedCase.id ? action.updatedCase : c
        ),
      };

    case PBTCasesActionType.UPDATE_CASE_ERROR:
      return {
        ...prev,
        isUpdating: false,
        updateError: action.errorMessage,
      };

    default:
      return prev;
  }
}
